import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';

export default function OceanBackground() {
  const mountRef = useRef(null);

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return;

    const WIND = 1.1;
    const HEIGHT = 1.9;
    const LIGHT = 0.9;

    const scene = new THREE.Scene();
    scene.fog = new THREE.Fog(0x4e1686, 20, 120);

    const camera = new THREE.PerspectiveCamera(55, window.innerWidth / window.innerHeight, 0.1, 500);
    camera.position.set(0, 8, 18);

    const renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setClearColor(0x4e1686);
    renderer.domElement.style.display = 'block';
    mount.appendChild(renderer.domElement);

    const geometry = new THREE.PlaneGeometry(200, 200, 200, 200);
    geometry.rotateX(-Math.PI / 2);

    const material = new THREE.MeshStandardMaterial({
      color: 0x9b6fe6,
      metalness: 0.6,
      roughness: 0.35
    });

    const ocean = new THREE.Mesh(geometry, material);
    scene.add(ocean);

    const ambient = new THREE.AmbientLight(0xbda6f5, 0.95);
    scene.add(ambient);

    const sun = new THREE.DirectionalLight(0xffffff, 1.5);
    sun.position.set(10, 20, 10);
    scene.add(sun);

    const basePositions = geometry.attributes.position.array.slice();
    let time = 0;
    let rafId;

    function animate() {
      time += 0.02 * WIND;
      const amp = HEIGHT;
      const pos = geometry.attributes.position.array;

      for (let i = 0; i < pos.length; i += 3) {
        const x = basePositions[i];
        const z = basePositions[i + 2];

        const wave1 = Math.sin(x * 0.15 + time) * amp;
        const wave2 = Math.cos(z * 0.2 + time * 1.3) * amp * 0.6;
        const wave3 = Math.sin((x + z) * 0.1 + time * 0.7) * amp * 0.4;

        pos[i + 1] = wave1 + wave2 + wave3;
      }

      geometry.attributes.position.needsUpdate = true;
      geometry.computeVertexNormals();

      const angle = LIGHT * Math.PI * 0.6 + 0.2;
      sun.position.set(Math.sin(angle) * 20, 20, Math.cos(angle) * 20);

      renderer.render(scene, camera);
      rafId = requestAnimationFrame(animate);
    }
    animate();

    function onResize() {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    }
    window.addEventListener('resize', onResize);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener('resize', onResize);
      mount.removeChild(renderer.domElement);
      geometry.dispose();
      material.dispose();
      renderer.dispose();
    };
  }, []);

  return <div ref={mountRef} className="ocean-bg" aria-hidden="true" />;
}
